import {
  type EventPayloadInput,
  type EventPayloadType,
} from "@package/ui-gql/index-analytics";
import { createContext, useContext } from "react";

export type WallAnalyticsContextState = {
  trigger<T extends EventPayloadType>(
    type: T,
    payload: EventPayloadInput[T],
    post?: string,
    layout?: string,
  ): void;
};

export const defaultWallAnalytics: WallAnalyticsContextState = {
  trigger: () => undefined,
};

export const WallAnalyticsContext =
  createContext<WallAnalyticsContextState>(defaultWallAnalytics);
export const useWallAnalytics = () => useContext(WallAnalyticsContext);
